import { Box, Stack } from '@mui/material';
import React from 'react';

import { AXON_LOGO_PATH } from '../utils/constants';

interface PageLayoutProps {
    children: React.ReactNode;
}

export const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            p: 3,
            textAlign: 'center',
        }}>
            <Stack spacing={4} alignItems="center" sx={{ width: '100%', maxWidth: 'md' }}>
                {/* Axon Logo Header */}
                <Box
                    component="img"
                    src={AXON_LOGO_PATH}
                    alt="Axon Logo"
                    sx={{
                        height: { xs: 40, sm: 50 },
                        width: 'auto',
                        mb: 2
                    }}
                />
                
                {/* Page Content */}
                <Box sx={{ width: '100%' }}>
                    {children}
                </Box>
            </Stack>
        </Box>
    );
};

export default PageLayout; 